import {BaseService} from "./BaseService";
import {EmployeeLocationHistory} from "../entities/EmployeeLocationHistory";
import { StateService } from "@uirouter/angularjs";
import { EmployeeWorkHours } from "../entities/EmployeeWorkHours";

export class EmployeeWorkHoursService extends BaseService<EmployeeWorkHours>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, EmployeeWorkHours);
    }
    protected getBaseUrl():string{
        return "employeelocationhistory";
    }
    protected getBasesUrl():string{
        return "employeelocationhistories";
    }
    getWorkHoursByEmployee(employeeId: number): ng.IPromise<EmployeeWorkHours[]> {
        var config: any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(), "employeeWorkHours/" + employeeId, config);
    }
}
